module.exports = __webpack_public_path__ + "img/cross-tuts.2e59891c.svg";